<template>
  <DashboardCard>
    <WdsStack direction-row gap-lg>
      <WdsButtonGhost
        v-for="metric in metrics"
        :key="metric.label"
        :href="metric.url"
        align-center
        direction-column
        class="tw-flex tw-flex-col tw-items-center tw-flex-1 tw-flex-grow tw-gap-2 tw-mb-4"
      >
        <WdsText>
          <template #default>
            <div class="tw-text-base tw-font-normal tw-font-sans">{{ metric.label }}</div>
          </template>
        </WdsText>
        <div class="tw-p-2">
          <Skeleton v-if="loading" class="tw-rounded tw-h-[50px] tw-w-[50px]" />
          <WdsText v-else>
            <template #default>
              <div class="tw-text-4xl tw-font-normal tw-font-display">
                {{ metric.value }}
              </div>
            </template>
          </WdsText>
        </div>
      </WdsButtonGhost>
    </WdsStack>
  </DashboardCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { WdsButtonGhost, WdsStack, WdsText } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import DashboardCard from '@/components/Dashboard/DashboardCard.vue'
import { DashboardMetricsQuery } from '@/components/Dashboard/Metrics/queries'
import Skeleton from '@/components/Dashboard/Widgets/Utils/Skeleton.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import laravelNamedRoutes from '@/utils/laravelNamedRoutes.json'

const clientId = 'publicApi'

const account = computed(() => currentAccount.globalId)

const { result, loading } = useQuery(
  DashboardMetricsQuery,
  () => ({
    accounts: [account.value],
  }),
  {
    clientId,
  },
)

const metrics = computed(() => [
  {
    label: $t('Unfilled jobs'),
    value: result.value?.unfilledJobs.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.jobs.index.created),
  },
  {
    label: $t('Active contracts'),
    value: result.value?.activeContracts.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.profiles.index.engaged),
  },
  {
    label: $t('Unsigned contracts'),
    value: result.value?.unsignedContracts.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.profiles.index.engaged),
  },
  {
    label: $t('Pending talent pool invites'),
    value: result.value?.talentPoolPendingInvites.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.contacts.index),
  },
])
</script>

<style lang="scss" scoped>
:deep(.wds-menu) {
  @apply tw-w-[200px];
}

:deep(.wds-menu-option-content) {
  @apply tw-w-full;
}
</style>
